import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthGuard from '../Services/AuthGuard';
import Layout from '../Components-V2/Layout/layout';
import Properties from '../Components-V2/Properties/Properties';
import Account from '../Components-V2/Login/account';
import Login from '../Components-V2/Login/login';
import PublicPagesGuard from '../Services/PublicPagesGuard';
import PropertyDetails from '../Components-V2/property-details/property-details';
import ListingCreation from '../Components-V2/listing-ceation/listing-creation';
import LayoutHeader from '../Components-V2/Layout/layout-header';
import EnhanceAndGenerate from '../Components-V2/EnhanceAndGenerate/enhance-generate';
import ListPost from '../Components-V2/Post/list-post';
import Post from '../Components-V2/Post/Post';
import ListingVideo from '../Components-V2/video/listing-video';
import ShareProperty from '../Components-V2/property-details/share-property';
import Settings from '../Components-V2/Settings/settings';
import Invitation from '../Components-V2/Users/invitation';
import Users from '../Components-V2/Users/users';
import CreatePropertyReport from '../Components-V2/Property-Report/create-property-report';
import AIDescriptionTitle from '../Components-V2/AI-Description-Title/AI-description-title';
import GenerateNewDescription from '../Components-V2/AI-Description-Title/generate-new-description';
import i18n from '../i18n';
import { Error404 } from '../Components-V2/Error404';
import HomePage from '../Components-V2/Home/home-page';
import Profile from '../Components-V2/Profile/Profile';


const PublicRouter: React.FunctionComponent<{}> = (props) => {


    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
            document.body.classList.toggle('rtl', savedLanguage === 'ar');
            document.body.classList.toggle('ltr', savedLanguage !== 'ar');
        }
    }, []);


    return (
        <>
            <Routes>
                <Route path="/account" element={<Account />} />
                <Route path="/acceptinvit/:id" element={<Invitation />} />
                <Route path="/property/:id" element={<ShareProperty />} />
                <Route path="/login" element={<PublicPagesGuard><Login /></PublicPagesGuard>} />
                <Route path="*" element={<AuthGuard><Navigate to="/404" /></AuthGuard>} />
                <Route path="/" element={<AuthGuard><Layout /></AuthGuard>} >
                    <Route path="" element={<AuthGuard><Navigate to="/properties" /></AuthGuard>} />
                    <Route path="/404" element={<AuthGuard><Error404 /></AuthGuard>} />
                    <Route path="/usage" element={<AuthGuard><HomePage /></AuthGuard>} />
                    <Route path="/properties" element={<AuthGuard><Properties /></AuthGuard>} />
                    <Route path="/poster" element={<AuthGuard><ListPost /></AuthGuard>} />
                    <Route path="/settings" element={<AuthGuard><Settings /></AuthGuard>} />
                    <Route path="/profile" element={<AuthGuard><Profile /></AuthGuard>} />
                    <Route path="/users" element={<AuthGuard><Users /></AuthGuard>} />
                    <Route path="/create-property-report" element={<AuthGuard><CreatePropertyReport /></AuthGuard>} />
                    <Route path="/create-property-report/:id" element={<AuthGuard><CreatePropertyReport /></AuthGuard>} />
                </Route>
                <Route path="/" element={<AuthGuard><LayoutHeader /></AuthGuard>}>
                    <Route path="/AI-description-and-title/generate-description" element={<AuthGuard><GenerateNewDescription /></AuthGuard>} />
                    <Route path="/AI-description-and-title" element={<AuthGuard><AIDescriptionTitle /></AuthGuard>} />
                    <Route path="/Listing-Creation" element={<AuthGuard><ListingCreation /></AuthGuard>} />
                    <Route path="/Enhance-Generate" element={<AuthGuard><EnhanceAndGenerate /></AuthGuard>} />
                    <Route path="/properties/:id" element={<AuthGuard><PropertyDetails /></AuthGuard>} />
                    <Route path="/create-listing-video" element={<AuthGuard><ListingVideo /></AuthGuard>} />
                    <Route path="/create-poster" element={<AuthGuard><ListPost /></AuthGuard>} />
                    <Route path="/generate-poster" element={<AuthGuard><Post /></AuthGuard>} />
                </Route>
            </Routes>

        </>
    );
};

export default PublicRouter;